<template lang="pug">
  div.schedule-layout
    
    div.schedule-list-wrapper
      vuetable(ref="vuetable"
        :api-mode="false"
        :css="boostrapCss"   
        :fields="fields"
        detail-row-component="schedule-detail"
        @vuetable:cell-clicked="onCellClicked"
      )
    div
      Calendar(v-on:setDatetime="getDatetime")


    //- div {{ scheduleList }}

</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import { faFemale, faMale } from '@fortawesome/free-solid-svg-icons';
import Calendar from '../../common/Calendar';
import ScheduleDetail from './ScheduleDetail';

Vue.component('schedule-detail', ScheduleDetail);
Vue.component('gender-template', {
  props: ['rowData'],
  template: `
    <font-awesome-icon :icon="maleIcon" v-if="rowData.patient.gender === 'male'" style="color: blue; width: 50px"/>
    <font-awesome-icon :icon="femaleIcon" v-else style="color: red; width: 50px"/>
  `,
  computed: {
    femaleIcon() {
      return faFemale;
    },
    maleIcon() {
      return faMale;
    },
  },
});


export default {
  name: 'ScheduleList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm table-sm',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
        },
      },
      fields: [
        {
          name: '__component:gender-template',
          title: '性別',
          titleClass: 'text-center gender-column',
          dataClass: 'text-center',
        },
        {
          name: 'patient.name',
          title: '病人名稱',
        },
        {
          name: 'patient.med_record_number',
          title: '病歷號',
        },
        {
          name: 'bed.code',
          title: '病床',
        },
        {
          name: 'time',
          title: '手術時間',
          callback: 'readableTime',
        },
        {
          name: 'medication.generic_name',
          title: '使用套組',
        },
      ],
      scheduleList: [],
    };
  },
  components: {
    Calendar,
    Vuetable,
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    getDatetime(val) {
      console.log(val);
      this.getScheduleListByDate(val);
    },
    getScheduleListByDate(date) {
      this.instance.get('/api/schedule/', {
        params: {
          date,
        },
      })
      .then((res) => {
        this.scheduleList = res.data;
        this.$refs.vuetable.setData(this.scheduleList);
      });
    },
    genderZh(val) {
      if (val === 'female') return '女';
      if (val === 'male') return '男';
      return null;
    },
    readableTime(val) {
      return val.split('T').join(' ');
    },
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
  },
};
</script>

<style lang="sass" scoped>
.schedule-layout
  display: inline-flex
  width: 100%

.schedule-list-wrapper
  width: calc(100% - 300px);
  padding: 0 10px

.gender-column
  width: 50px
</style>



// WEBPACK FOOTER //
// ScheduleList.vue?23b0430f